import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {UtilService} from '../shared/services/util.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'app-dialog-transfer',
  templateUrl: './dialog-transfer.component.html',
  styleUrls: ['./dialog-transfer.component.scss']
})
export class DialogTransferComponent implements OnInit {
repos;
  constructor(private dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public utilService: UtilService) { }

  ngOnInit() {
   this.utilService.getActiveLocations().subscribe(res => {
       this.repos = res;
   });
   console.log('DATA', this.data);
  }
  onSave(f: NgForm) {
      console.log(f.value)
      this.dialogRef.close(f.value);
  }
  onClose() {
      this.dialogRef.close();
  }
onTest(data) {
      console.log(data)
}
}
